import React from 'react'
import { Layout, Header } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import ImageHero from 'app/theme/ImageHero'
import largeEventBanner from 'assets/img/large-event-banner.png'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import eventLALive from 'assets/img/LA-live-event.jpg'
import largeEventGridImage from 'assets/img/large-event-grid-image.jpg'
import largeEventImage from 'assets/img/large-event.png'
import NavbarFixed from 'app/theme/NavbarFixed'
import { useInView } from 'react-intersection-observer'

export default function LargeEventConcessionsPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <meta name="description" content="Roaming Hunger is a nationwide company that provides full service experiences and concessions for festivals, conferences, and other large events." />
        <meta name="og:title" content="Large Event Food and Beverage Concessions and Experiences" />
        <title>Large Event Food and Beverage Concessions and Experiences - Roaming Hunger</title>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={largeEventBanner}
          title="Extraordinary Food Experiences for Large Events"
          description="Win lifetime fans, hearts and minds with a food program designed to impress and engage."
          onButtonClick={openModal}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}
      <Intro />
      <OccasionPageGrid>
        <OccasionPageGridRow
          heading="We’re Your Full-Service F&B Solution"
          content="Food and beverage may be the foundation of the event, but it doesn’t stop there. We’ll turn your event concessions into a memorable, shareable experience with branded food courts, Instagram-worthy installations, and can’t-put-em-down games… all while managing every piece of the puzzle from infrastructure, design, and vendor management."
          image={largeEventGridImage}
          reverse
        />
      </OccasionPageGrid>
      <WhyWorkWithUs onButtonClick={openModal}/>
      <div className='w-full container mb-12 hidden md:block'>
        <img src={largeEventImage} />
      </div>
      <CuisineTypes baseUrl='/food-truck-catering' />
      <HowItWorks heading="How Large Event Food Concessions Works" onButtonClick={openModal} />
      <HowItWorksLarge heading="How Large Event Food Concessions Works" onButtonClick={openModal} />
      <LargeEventPartners />
    </Layout>
  )
}

function Intro() {
  return (
    <div className="container text-center mt-12 mb-10">
      <h2 className="text-navy text-4xl leading-tight font-platform">
      Your success is our success.<br/>That’s why we’ve been at this for nearly a decade.
      </h2>
      <p className="font-light text-gray-900 mt-6">
        We’re experts at understanding our partners’ needs and creating scalable custom food and beverage programs to meet your goals.
      </p>
    </div>
  )
}

function LargeEventPartners() {
  return (
    <div className="bg-gray-200">
      <div className="container py-16 flex flex-wrap font-national">
        <div className="w-full md:w-1/2 md:pr-4 flex-auto self-center">
          <img src={eventLALive} className="w-full" />
        </div>
        <div className="w-full md:w-1/2 md:pr-20 md:pl-16 py-3">
          <h3 className="text-navy text-2xl">Event Partners We’ve Worked With</h3>
          <p className="font-light text-gray-900">
            We've provided scalable solutions to all types of companies and events, including:
          </p>
          <ul className="font-light text-gray-900 list-disc list-outside pl-10">
            <li>Disneyland</li>
            <li>Special Olympics 2016</li>
            <li>ANA Inspiration LPGA Tournament</li>
            <li>Founder’s Cup</li>
            <li>Cedar Point Amusement Park in Ohio</li>
            <li>Spartan Race Series</li>
            <li>FORM Music Festival in Arcosanti, AZ</li>
            <li>Whisky X Event series in LA, Chicago, NYC, Miami, and Denver</li>
            <li>Association of Volleyball Professional Competitions in Austin, Seattle, San Francisco, and Huntington Beach</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
